import * as T from "./actionTypes";
import {
  Audience,
  AudienceSegment,
  AudienceSummary,
  AudienceTravelTime,
  GeoFenceLocation,
  SiteCatchment,
  ValidFile,
  Variable,
} from "@/types";

export type BuildResult = {
  audience_id?: string;
  audience_geo: string;
  audience_size?: AudienceSummary[];
};

export type AudienceAction =
  | { type: typeof T.LOAD_AUDIENCE; payload: Audience | null }
  | { type: typeof T.CREATE_AUDIENCE }
  | { type: typeof T.SAVED_AUDIENCE; payload: Audience }
  | { type: typeof T.BUILD_AUDIENCE; payload: BuildResult }
  | { type: typeof T.RESET }
  | { type: typeof T.ADD_SEGMENTS; payload: AudienceSegment[] }
  | { type: typeof T.CHANGE_SEGMENT; payload: AudienceSegment }
  | { type: typeof T.CHANGE_NAME; payload: { audienceId: string; audienceName: string; projectName: string | null } }
  | { type: typeof T.SHARE_AUDIENCE; payload: { audienceId: string; userIds: number[] } }
  | { type: typeof T.ADD_VARIABLE_GROUP }
  | { type: typeof T.REMOVE_VARIABLE_GROUP; payload: number }
  | { type: typeof T.RESET_VARIABLE_GROUP; payload: number }
  | { type: typeof T.CHANGE_OPERATOR; payload: string }
  | { type: typeof T.CHANGE_GROUP_OPERATOR; payload: { id: number; operator: string } }
  | { type: typeof T.CHANGE_GROUP_VARIABLES; payload: { id: number; variables: Variable[] } }
  | { type: typeof T.ADD_VARIABLES; payload: { id: number; variables: Variable[] } }
  | { type: typeof T.REMOVE_VARIABLE; payload: { id: number; tagId: number } }
  | { type: typeof T.CHANGE_BUILD_MODE; payload: string }
  | { type: typeof T.SET_GEO_FENCE; payload: GeoFenceLocation[] }
  | { type: typeof T.ADD_UPLOAD_FILE; payload: File }
  | { type: typeof T.CLEAR_UPLOAD_FILE }
  | { type: typeof T.CHECK_UPLOAD_FILE; payload: ValidFile | null }
  | { type: typeof T.CHANGE_UPLOAD_MODE; payload: string }
  | { type: typeof T.CHANGE_TRAVELTIME; payload: Partial<AudienceTravelTime> }
  | { type: typeof T.SET_SITES; payload: number[] }
  | { type: typeof T.SET_SITE_CATCHMENT; payload: SiteCatchment[] }
  | { type: typeof T.SET_SITE_CATEGORIES; payload: string[] }
  | { type: typeof T.SET_SITE_DAY_TYPE; payload: string };

/**
 * The audience being viewed or edited. Fetched data (lists, insights, request
 * status) lives in the query cache, and the activation in ActivationContext.
 */
export interface AudienceState {
  currentAudience: Audience | null;
  currentDefinition: string | null; // The saved definition, to tell whether it's changed
  currentSegment: AudienceSegment | null;
  validFile: ValidFile | null;
}

export const initialState: AudienceState = {
  currentAudience: null,
  currentDefinition: null,
  currentSegment: null,
  validFile: null,
};
